export const ANYWHERE_NETWORK = 'Marathon Health - CareAnywhere / Virtual';
